import React from 'react';

/**
 * Checks if a URL points to an external domain
 * @param url - The URL to check
 * @returns `true` if the URL points to an external domain, `false` otherwise
 */
export function isExternalUrl(url: string): boolean {
  if (!url || url.startsWith('/') || url.startsWith('.') || url.startsWith('#')) {
    return false;
  }

  try {
    const parsedCurrent = new URL(process.env.GATSBY_SITE_URL);
    const parsed = new URL(url);

    return parsed.hostname !== parsedCurrent.hostname;
  } catch (e) {
    console.error(`Error parsing URL "${url}":`, e);
    return false;
  }
}

/**
 * Determines the appropriate anchor target attribute based on whether the URL is external or internal.
 * Returns '_blank' for external URLs (opening in a new tab/window) and '_self' for internal URLs.
 *
 * @param url - The URL string to analyze
 * @returns Either '_blank' for external URLs or '_self' for internal URLs
 */
export function getAnchorTarget(
  url: string,
): Extract<React.HTMLAttributeAnchorTarget, '_self' | '_blank'> {
  return isExternalUrl(url) ? '_blank' : '_self';
}
